var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.componentClass, style: _vm.componentStyle },
    [
      _c("label", { class: _vm.labelClass, attrs: { for: _vm.sluggedLabel } }, [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "select-custom",
            { "with-icon-before position-relative": _vm.hasIcon },
          ],
          attrs: {
            "aria-label": _vm.componentTooltip,
            "data-balloon-pos": "up",
          },
        },
        [
          _vm.hasIcon
            ? _c("font-awesome-icon", {
                staticClass: "select-custom-icon position-absolute",
                attrs: { icon: _vm.$v7[_vm.iconStyle][_vm.iconName] },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "select",
            {
              class: _vm.selectClass,
              style: _vm.selectStyle,
              attrs: {
                id: _vm.sluggedLabel,
                disabled: _vm.isDisabled,
                required: _vm.isRequired,
              },
              on: {
                blur: _vm.onBlur,
                focus: function ($event) {
                  return _vm.$emit("focus")
                },
                input: function ($event) {
                  return _vm.$emit("change", $event.target.value)
                },
              },
            },
            [
              _vm._t("options", function () {
                return _vm._l(_vm.options, function (option) {
                  return _c(
                    "option",
                    {
                      key: option.name,
                      attrs: {
                        disabled: option.disabled === true ? "disabled" : null,
                      },
                      domProps: {
                        value: option.value,
                        selected:
                          option.value === _vm.value ? "selected" : null,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(option[_vm.optionLabelProp]) +
                          "\n        "
                      ),
                    ]
                  )
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("tip", function () {
        return [
          _vm.tip
            ? _c("p", { staticClass: "tip margin-top-2xs margin-bottom-0" }, [
                _vm._v("\n      " + _vm._s(_vm.tip) + "\n    "),
              ])
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }